import { RiMenu3Fill } from "react-icons/ri";
import { useDispatch } from "react-redux";
import { setIsOpenMenu } from "../../redux/actions/menuActions/menuActions";

const MenuUi = ({ className }) => {
  const dispatch = useDispatch();

  return (
    <div
      onClick={() => dispatch(setIsOpenMenu())}
      className={` ${className} absolute right-2 z-50 lg:hidden none`}
    >
      <span className="cursor-pointer">
        <RiMenu3Fill size={30} color="#fff" />
      </span>
    </div>
  );
};

export default MenuUi;
